<template>
  <div :class="['d-flex align-items-center', wrapperClass]">
    <b-form-checkbox
      v-model="isRulerShown"
      class="show-ruler-checkbox"
      inline
      @change="onShowRulerChange"
    >
      Show ruler
    </b-form-checkbox>
    <b-icon
      id="rulerTooltip"
      class="show-ruler-help cursor-pointer"
      icon="question-circle"
    />
    <b-tooltip
      target="rulerTooltip"
      triggers="hover"
    >
      <div class="ruler-tooltip">
        Hover the cursor on the ruler and press the left mouse button to create a line.
        <br> Hover the cursor on the horizontal ruler and press <strong>Shift + Left Mouse Button</strong> to remove the last added horizontal line.
        <br> Hover the cursor on the vertical ruler and press <strong>Shift + Left Mouse Button</strong> to remove the last added vertical line.
      </div>
    </b-tooltip>
    <b-button
      v-if="rulerLinesCount"
      v-b-tooltip.hover.viewport.noninteractive="`Reset lines`"
      variant="outline-primary"
      size="sm"
      class="ml-2"
      @click="removeAllLines"
    >
      <b-icon icon="arrow-clockwise" />
    </b-button>
  </div>
</template>

<script>
import { rulerEventsBroker, EVENTS as RULER_EVENTS } from "@frontend/group/modules/ruler/event-broker";
import { mapGetters } from 'vuex'

export default {
  name: 'ShowRulerComponent',
  
  props: {
    wrapperClass: {
      type: String,
      default: ''
    }
  },
  
  data: () => ({
    isRulerShown: false
  }),

  computed: {
    ...mapGetters('layout', [
      'selectedInstance',
      'currentPagePreviews'
    ]),
    rulerLinesCount() {
      if (!this.selectedInstance || !this.selectedInstance.ruler) return 0;
      return _.sumBy(_.values(this.selectedInstance.ruler.linesByType), 'length');
    }
  },

  watch: {
    'selectedInstance.ruler.isRulerShown'(val) {
      this.isRulerShown = val;
    },
    currentPagePreviews() {
      this.loadRulerSettings();
    }
  },

  mounted() {
    rulerEventsBroker.on(RULER_EVENTS.RULER_LINES_CHANGES, this.onRulerSettingsChanged);
    rulerEventsBroker.on(RULER_EVENTS.REINITIALIZE, this.loadRulerSettings);
    // this.loadRulerSettings();
  },

  methods: {
    onShowRulerChange(val) {
      if (!this.selectedInstance || !this.selectedInstance.ruler) return;
      
      const ruler = this.selectedInstance.ruler;
      ruler.toggle(val);
      this.onRulerSettingsChanged();
    },
    
    removeAllLines() {
      if (!this.selectedInstance || !this.selectedInstance.ruler) return;
      
      this.selectedInstance.ruler.removeAllLines();
    },
    
    loadRulerSettings() {
      const previews = this.currentPagePreviews || [];
      previews.forEach((instance) => {
        const savedRulerSettings = instance.data?.rulerSettings || {};
        // Restore all lines
        savedRulerSettings.lines?.forEach(line => {
          instance.ruler.addLine({
            x1: line.x1,
            y1: line.y1,
            x2: line.x2,
            y2: line.y2,
            stroke: line.color,
            strokeWidth: line.thickness,
            type: line.type
          });
        });
        const isRulerShown = savedRulerSettings.isRulerShown || false;
        instance.ruler.isRulerShown = isRulerShown;
        if (isRulerShown) {
          instance.ruler.toggle(isRulerShown);
        }
      });
    },
    
    async onRulerSettingsChanged() {
      if (!this.selectedInstance || !this.selectedInstance.ruler) return;
      
      const ruler = this.selectedInstance.ruler;
      const allLines = _.flatMap(['horizontal', 'vertical'], type =>
        ruler.linesByType[type].map(line => {
          const coords = line.calcCoords();
          return {
            x1: coords.bl.x,
            y1: coords.tl.y,
            x2: type === 'vertical' ? coords.bl.x : coords.br.x,
            y2: type === 'vertical' ? coords.bl.y : coords.tl.y,
            color: line.stroke,
            thickness: line.strokeWidth,
            type
          };
        })
      );
      const payload = [{
        instance_id: this.selectedInstance.id,
        key: 'rulerSettings',
        value: {
          isRulerShown: ruler.isRulerShown,
          lines: allLines
        },
      }];

      //save ruler settings on toggle instead of using Save btn
      const grid = $("#template-group-preview");
      const customer_id = grid.attr("data-customer-id");
      const layout_id = grid.attr("data-layout-id");

      try {
        await axios.put(
          `/banner/${customer_id}/group/${layout_id}/save_changes`,
          payload
        );
      } catch (e) {
        console.warn('Something went wrong. Failed saving ruler settings');
      }
      // rulerEventsBroker.fire(RULER_EVENTS.RULER_CHANGES, payload);
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .ruler-tooltip {
    max-width: 200px;
    text-align: left;
  }

  .show-ruler-checkbox.custom-control {
    min-height: 1.25rem;
    margin-right: .25rem;
    padding-left: 1.5rem;
  }

  .custom-control-label {
    display: inline-flex;
    align-items: center;
    min-height: 1.25rem;
    color: inherit;
    font-weight: 400 !important;
    font-size: .875rem;
    line-height: 1.25rem;
  }

  .show-ruler-checkbox .custom-control-label::before,
  .show-ruler-checkbox .custom-control-label::after {
    top: .125rem;
    width: 1rem;
    height: 1rem;
  }
}

.show-ruler-help {
  width: .875rem;
  height: .875rem;
  flex: 0 0 .875rem;
  color: #6b7280;
}
</style>
